import { render, staticRenderFns } from "./AddIntegrationItem.vue?vue&type=template&id=12b24878&scoped=true"
import script from "./AddIntegrationItem.vue?vue&type=script&lang=js"
export * from "./AddIntegrationItem.vue?vue&type=script&lang=js"
import style0 from "./AddIntegrationItem.vue?vue&type=style&index=0&id=12b24878&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b24878",
  null
  
)

export default component.exports